<template>
    <Button label="Atualizar" icon="pi pi-pencil" @click="toAtualizar()" class="ml-2" />
</template>

<script>
export default {
    props: {
        evento: {
            type: Object,
        },
    },

    methods: {
        toAtualizar() {
            this.$router.push({
                name: 'Checkins_Eventos_Atualizar',
                params: {
                    id: this.evento.eventoId,
                },
            });
        },
    },
};
</script>
